import get from 'lodash/get';
import { dateFromString } from 'lib/date';

export const getIsPointsPay = (state) => state.ui.isPointsPay;
export const getMapHoveredPropertyId = (state) => state.ui.mapHoveredPropertyId;
export const getMapActivePropertyId = (state) => state.ui.mapActivePropertyId;

export const getDateChangeMessaging = (state) => ({
  isVisible: !!get(state, 'ui.dateChangeMessaging.isVisible'),
  checkIn: dateFromString(get(state, 'ui.dateChangeMessaging.checkIn')),
  checkOut: dateFromString(get(state, 'ui.dateChangeMessaging.checkOut')),
});

export const getAppVersion = (state) => state.ui?.appVersion;
export const getAppOutOfDate = (state) => !!state.ui?.appOutOfDate;

export const getPropertyFiltersModalVisible = (state) => state.ui.propertyFiltersModalVisible;
